import React, { useState, useEffect } from 'react';
import MobileFilterCollapse, { searchSummary } from '../common/form/MobileFilterCollapse';
import { Box, Button, MenuItem, Stack, TextField } from '@mui/material';
import {
  firstDayofYear,
  getFirstDayOfYear,
  getLastDayOfYear,
  lastDayofYear,
  subYearStrDt,
} from '../../utils/calcDatetime';
import 'dayjs/locale/ko';
import SalesDeptUserFilter from '../common/form/SalesDeptUserFilter';
import dayjs from 'dayjs';
import SearchCodeSelectbox from '../common/form/selectbox/SearchCodeSelectbox';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DateAdapter from '@mui/lab/AdapterDateFns';
import MobileSearchAdornment from '../common/search/MobileSearchAdornment';

//----------------------------------------------------

export const ProjectListBox = ({ formik }) => {
  const [searchStrtDt, setSearchStrtDt] = useState(null);
  const [searchEndDt, setSearchEndDt] = useState(null);

  useEffect(() => {
    if (formik.values.searchStrtDt) {
      setSearchStrtDt(dayjs(formik.values.searchStrtDt));
    }
    if (formik.values.searchEndDt) {
      setSearchEndDt(dayjs(formik.values.searchEndDt));
    }
  }, [formik.values?.searchStrtDt, formik.values?.searchEndDt]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  const handleChangeThisYear = () => {
    formik.setFieldValue('searchStrtDt', firstDayofYear);
    formik.setFieldValue('searchEndDt', lastDayofYear);
  };
  const handleChangeLastYear = () => {
    const paramDate = subYearStrDt(1);

    const strDt = getFirstDayOfYear(paramDate);
    const endDt = getLastDayOfYear(paramDate);

    formik.setFieldValue('searchStrtDt', strDt);
    formik.setFieldValue('searchEndDt', endDt);
  };

  return (
    <MobileFilterCollapse summary={searchSummary(formik.values)}>
    <div>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          justifyContent: 'flex-end',
          alignItems: { xs: 'stretch', lg: 'center' },
          gap: { xs: 1, lg: 1.5 },
          my: 1,
        }}
        onSubmit={formik.handleSubmit}
      >
        {/* 포캐스팅 리스트와 같은 배치를 쓴다. 검색 조건이 화면마다 다르게 놓이면
            같은 업무를 오가는 사용자가 매번 눈으로 다시 찾아야 한다. */}
        <Box
          sx={{
            flexGrow: 1,
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(4, minmax(140px, 1fr))',
              xl: 'minmax(120px, 1fr) minmax(120px, 1fr) 165px 165px auto minmax(110px, 0.8fr) minmax(110px, 0.8fr) minmax(130px, 1.2fr)',
            },
            alignItems: 'end',
            gap: { xs: 1.25, md: 1.5 },
            minWidth: 0,
            '& .MuiFormControl-root': {
              width: '100%',
            },
          }}
        >
          <SalesDeptUserFilter formik={formik} />

          <Box sx={{ minWidth: 0 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 시작일"
                format="YYYY-MM-DD"
                id="searchStrtDt"
                name="searchStrtDt"
                value={dayjs(searchStrtDt)}
                onChange={(newValue) => {
                  setSearchStrtDt(dayjs(newValue));
                  formik.setFieldValue('searchStrtDt', dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="매출 종료일"
                format="YYYY-MM-DD"
                id="searchEndDt"
                name="searchEndDt"
                value={dayjs(searchEndDt)}
                onChange={(newValue) => {
                  setSearchEndDt(dayjs(newValue));
                  formik.setFieldValue('searchEndDt', dayjs(newValue));
                }}
                slotProps={{
                  textField: {
                    variant: 'standard',
                    fullWidth: true,
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: 'center',
              '& .MuiButton-root': {
                flex: { xs: 1, sm: 'initial' },
                minWidth: { xs: 0, sm: 64 },
              },
            }}
          >
            <Button variant="outlined" color="info" onClick={handleChangeThisYear}>
              금년
            </Button>
            <Button variant="outlined" color="info" onClick={handleChangeLastYear}>
              작년
            </Button>
          </Stack>
          <SearchCodeSelectbox
            formik={formik}
            variant="standard"
            name="searchPrjImpt"
            label="프로젝트 중요도"
            required={false}
            fullWidth
            filterObject={{
              blcCd: 'BASE',
              mlcCd: 'FORCAST',
              slcCd: 'PRJ_IMPT',
            }}
          />
          <TextField
            variant="standard"
            required={false}
            select
            id="searchKeyword"
            name="searchKeyword"
            label="검색키워드"
            value={formik.values.searchKeyword}
            onChange={formik.handleChange}
            error={formik.touched.searchKeyword && Boolean(formik.errors.searchKeyword)}
            helperText={formik.touched.searchKeyword && formik.errors.searchKeyword}
          >
            <MenuItem value="prjNo">프로젝트 번호</MenuItem>
            <MenuItem value="cstNm">사업명</MenuItem>
            <MenuItem value="vendorCmpNm">매출처명</MenuItem>
            <MenuItem value="crtNm">영업담당자</MenuItem>
          </TextField>
          <TextField
            variant="standard"
            required={false}
            id="searchWords"
            name="searchWords"
            label="검색어"
            value={formik.values.searchWords}
            onChange={formik.handleChange}
            error={formik.touched.searchWords && Boolean(formik.errors.searchWords)}
            helperText={formik.touched.searchWords && formik.errors.searchWords}
            InputProps={{
              endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
            }}
          />
        </Box>
        <Box sx={{ width: { xs: '100%', lg: 'auto' } }}>
          <Button
            type="submit"
            color="info"
            variant="contained"
            disabled={formik.isSubmitting}
            fullWidth
            sx={{ minHeight: 40, px: 3, whiteSpace: 'nowrap', minWidth: 88 }}
          >
            검색
          </Button>
        </Box>
      </Box>
    </div>
    </MobileFilterCollapse>
  );
};
